import React, { useMemo, useRef } from 'react';
import { trackButtonActivity } from 'src/functions/propagateQueryParams';
import { palette } from 'src/styles/colors';
import getButtonStyleByColorScheme, { ColorScheme } from 'src/styles/functions/getButtonStyleByColorScheme';
import { StyledLinkIconSpan } from '../links/Link.simple.styles';
import { StyledButtonTertiary } from './Button.tertiary.styles';

interface ButtonTertiaryProps {
  onClick?: () => void;
  text?: string;
  id?: string;
  type?: 'button' | 'submit';
  underlined?: boolean;
  cursor?: 'auto' | 'pointer';
  color?: 'main' | 'text' | 'violet' | 'yellow';
  colorScheme?: ColorScheme;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  justify?: 'stretch' | 'center' | 'left' | 'right';
}

const ButtonTertiary = ({
  onClick,
  text,
  id,
  type,
  justify,
  color,
  underlined,
  icon,
  iconPosition,
  cursor,
  colorScheme = 'Standard',
}: ButtonTertiaryProps): JSX.Element => {
  const buttonRef = useRef<HTMLButtonElement>();
  const linkColors = useMemo(() => getButtonStyleByColorScheme(colorScheme, 'tertiary'), []);

  // Extend onClick listener for Trackers, etc.
  const trackOnClick = () => {
    if (onClick) {
      onClick();
    }
    // >> Additional trackers
    trackButtonActivity(buttonRef.current, text);
  };

  return (
    <StyledButtonTertiary
      id={id ?? 'styled-button-tertiary'}
      ref={buttonRef}
      onClick={trackOnClick}
      justify={justify}
      cursor={cursor}
      textColor={color === 'text' ? palette.text : linkColors.textColor}
      hasIcon={!!icon}
      iconPosition={iconPosition}
      type={type ?? 'button'}
      underlined={!!underlined}
    >
      {icon ? (
        <StyledLinkIconSpan
          iconPosition={iconPosition}
          color={color}
        >
          {' '}
          {icon}
        </StyledLinkIconSpan>
      ) : null}
      {text ? <span>{text}</span> : null}
    </StyledButtonTertiary>
  );
};

export default ButtonTertiary;
